import { listItemSelectBuilder, MultiSelect } from '@wix/design-system'
import { DropdownLayoutValueOption } from '@wix/design-system/dist/types/DropdownLayout'
import { MultiSelectTag } from '@wix/design-system/dist/types/MultiSelect'
import React, { FC } from 'react'

import { usePageLogger } from '../../../../bi/mfi'
import { selectPopoverProps } from '../config/SelectPopoverProps'
import { useSecondTryContext } from '../SecondTryContext/SecondTryContext'
import { TSecondTry } from '../typings/SecondTry.content'

interface WidgetAppsMultiSelectProps {
  question: TSecondTry['widget']['content']['apps']
}

export const WidgetAppsMultiSelect: FC<WidgetAppsMultiSelectProps> = ({ question }) => {
  const pageLogger = usePageLogger()
  const { dispatch, selectedAppDefIds, isRecommendedAppsLoading, recommendedApps } = useSecondTryContext()

  const handleOnSelect = (option: DropdownLayoutValueOption) => {
    dispatch({
      type: 'setSelectedAppDefIds',
      appDefIds: [...(selectedAppDefIds ?? []), option.id as string],
    })
    void pageLogger.generalAction({ action: 'edit_apps', questionKey: question.questionKey })
  }

  const handleOnRemoveTag = (tagId: string) => {
    dispatch({
      type: 'setSelectedAppDefIds',
      appDefIds: (selectedAppDefIds ?? []).filter(id => id !== tagId),
    })
    void pageLogger.generalAction({ action: 'edit_apps', questionKey: question.questionKey })
  }

  const options = recommendedApps.map(app => ({
    ...app,
    ...listItemSelectBuilder({
      id: app.appDefId,
      title: app.name,
      subtitle: app.description,
    }),
  }))

  const tags = selectedAppDefIds
    .map(appDefId => {
      const app = recommendedApps.find(a => a.appDefId === appDefId)
      if (!app) {
        return false
      }

      const isBuiltIn = app.level === 'built-in'
      return {
        id: app.appDefId,
        label: isBuiltIn ? `Built-In: ${app.name}` : app.name,
        size: 'tiny',
        removable: !isBuiltIn,
        disabled: isBuiltIn,
      }
    })
    .filter(Boolean) as MultiSelectTag[]

  return (
    <MultiSelect
      size="small"
      options={options}
      tags={tags}
      onSelect={handleOnSelect}
      onRemoveTag={handleOnRemoveTag}
      popoverProps={selectPopoverProps}
      status={isRecommendedAppsLoading ? 'loading' : undefined}
    />
  )
}
